import { render, staticRenderFns } from "./assignCourseLeaderModal.vue?vue&type=template&id=0ce71e33&scoped=true&lang=pug"
import script from "./assignCourseLeaderModal.vue?vue&type=script&lang=js"
export * from "./assignCourseLeaderModal.vue?vue&type=script&lang=js"
import style0 from "./assignCourseLeaderModal.vue?vue&type=style&index=0&id=0ce71e33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce71e33",
  null
  
)

export default component.exports